// ═══════════════════════════════════════════════════════════════════════════
// Dependencias compartidas de los PDF
// Extraídas literal de index.html v0.9.16.
//
// ⚠ REMITENTE es el emisor fiscal HARDCODEADO. En el modelo multi-inquilino
//   viene de tenant. Se conserva aquí para no cambiar comportamiento; en la
//   Etapa 4 se inyecta.
// ═══════════════════════════════════════════════════════════════════════════

export const REMITENTE = {
  name: "KATIA CHAVEZ ELIZALDE",
  rfc: "CAEK9607035N6",
  street: "JUAN N MENDEZ 259",
  colonia: "BUENAVENTURA",
  cp: "22880",
  city: "ENSENADA",
  state: "BAJA CALIFORNIA",
  whatsapp: "646 2947831",
  email: "vinicolatotal@gmail.com",
  bank: "Banco del Bajío (Banbajío)",
  clabe: "030022900023752386",
};

export const fmt = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n);
